import React from 'react';
import PropTypes from 'prop-types';

const ArrowChevronRightIcon = ({
  style = {},
  fill = '',
  width = '100%',
  height = '100%',
  className = '',
  viewBox = '0 0 24 24',
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm-1.218 19L9 17.25 14.25 12 9 6.75 10.782 5l6.968 7-6.968 7z"
    />
  </svg>
);

ArrowChevronRightIcon.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  className: PropTypes.string,
  viewBox: PropTypes.string,
  fillRule: PropTypes.string,
};

export default ArrowChevronRightIcon;
